import { CLINIC_MANAGER_NAV_TRANSLATIONS } from "@/domains/shared/navigation/constants";
import type { IUser } from "@/domains/shared/models/IUser";
import { resolveTeamChatActive } from "@/domains/shared/services/secretaryClinicalPaths";
import { getTranslation } from "@mivo/i18n";
import type { LucideIcon } from "lucide-react";
import { Building2, DollarSign, LayoutDashboard, MapPin, MessageCircle, Settings, Store, Users } from "lucide-react";

export type ClinicManagerNavItem = {
    to: string;
    label: string;
    icon: LucideIcon;
    end?: boolean;
};

const CLINIC_TEAM_CHAT_PATH = "/clinica/chat-equipe";

/** Sidebar footer link (above profile) — not part of scrollable Multi manager nav. */
export function clinicManagerProfessionalNavItem(): ClinicManagerNavItem {
    return {
        to: "/profissional",
        label: getTranslation(CLINIC_MANAGER_NAV_TRANSLATIONS.professionalOffice),
        icon: LayoutDashboard,
    };
}

export function buildClinicManagerNav(user?: IUser | null): ClinicManagerNavItem[] {
    const nav: ClinicManagerNavItem[] = [
        {
            to: "/clinica",
            label: getTranslation(CLINIC_MANAGER_NAV_TRANSLATIONS.clinicData),
            icon: Building2,
            end: true,
        },
        { to: "/clinica/unidades", label: getTranslation(CLINIC_MANAGER_NAV_TRANSLATIONS.units), icon: MapPin },
        { to: "/clinica/equipe", label: getTranslation(CLINIC_MANAGER_NAV_TRANSLATIONS.team), icon: Users },
        { to: CLINIC_TEAM_CHAT_PATH, label: getTranslation(CLINIC_MANAGER_NAV_TRANSLATIONS.teamChat), icon: MessageCircle },
        { to: "/clinica/configuracoes", label: getTranslation(CLINIC_MANAGER_NAV_TRANSLATIONS.settings), icon: Settings },
        { to: "/clinica/marketplace", label: getTranslation(CLINIC_MANAGER_NAV_TRANSLATIONS.marketplace), icon: Store },
        { to: "/clinica/assinatura", label: getTranslation(CLINIC_MANAGER_NAV_TRANSLATIONS.subscription), icon: DollarSign },
    ];

    if (!resolveTeamChatActive(user)) {
        return nav.filter((item) => item.to !== CLINIC_TEAM_CHAT_PATH);
    }

    return nav;
}

export function buildClinicManagerMobileNav(user?: IUser | null): ClinicManagerNavItem[] {
    return [...buildClinicManagerNav(user), clinicManagerProfessionalNavItem()];
}
